// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { MUST_SEARCH_AT_LEAST_ONE_VALUE } from 'errors'
import {
  assembleQuery,
  fetchAntennaSpecsByQuery,
  makePaginationParams,
} from 'helpers/api'
import { valueAsMeters } from 'helpers/unitConversion'

const fetchData = formArgs => {
  const {
    formProps,
    formValues,
    queryBasis = [],
    includeFlags = [],
    submittedFormIsPristine,
  } = formArgs

  const search = [...queryBasis]

  if (formValues.antennaCode) {
    search.push({
      value: formValues.antennaCode,
      field: 'antennaCode',
      operator: 'LIKE',
    })
  }

  if (formValues.companyName) {
    search.push({
      value: formValues.companyName,
      field: 'companyName',
      operator: 'LIKE',
    })
  }

  if (formValues.modelNumber) {
    search.push({
      value: formValues.modelNumber,
      field: 'modelNumber',
      operator: 'LIKE',
    })
  }

  if (formValues.classificationId) {
    search.push({
      value: formValues.classificationId,
      field: 'classificationId',
      operator: 'EQ',
    })
  }

  // API assumes diameter is in meters. convert from feet if necessary
  if (formValues.diameter) {
    search.push({
      value: valueAsMeters(formValues.diameter, formValues.diameterUnit),
      field: 'diameter',
      operator: 'EQ',
    })
  }

  // form must have at least one value
  if (search.length === queryBasis.length) {
    throw new Error(MUST_SEARCH_AT_LEAST_ONE_VALUE)
  }

  const page = (
    formValues.pagination && submittedFormIsPristine(formProps.form)
      ? +formValues.pagination.page
      : 0
  )

  // size of results set in API response - default to 500 count
  const size = 500

  const paginationParams = makePaginationParams({
    page,
    size,
  })

  const query = [{
    field: 'search',
    value: [search],
  },
  ...includeFlags,
  ...paginationParams,
  ]

  return fetchAntennaSpecsByQuery(assembleQuery(query))
}

export default fetchData
